/**
 * Чистый канонический scan: первая подходящая инструкция резервирует конкретную
 * Реакцию. Результат — только JSON-данные, пригодные для package playback/replay.
 * Authoritative armed-zone подключается к этому шву в M14.
 */
export function planReactionTriggerInstructions(instructions, candidates) {
    const ordered = [...candidates].sort((a, b) => a.seq - b.seq || a.reactionInstanceId.localeCompare(b.reactionInstanceId));
    const reserved = new Set();
    const result = [];
    instructions.forEach((instruction, damageInstructionIndex) => {
        for (const candidate of ordered) {
            if (reserved.has(candidate.reactionInstanceId))
                continue;
            const planned = candidate.plan(structuredClone(instruction), [...reserved]);
            if (planned === null)
                continue;
            if (!Number.isFinite(planned.replacement.base) || !Number.isFinite(planned.replacement.amount)) {
                throw new Error(`planReactionTriggerInstructions: Реакция "${candidate.reactionInstanceId}" вернула нечисловой урон`);
            }
            reserved.add(candidate.reactionInstanceId);
            result.push({
                reactionInstanceId: candidate.reactionInstanceId,
                damageInstructionIndex,
                replacement: structuredClone(planned.replacement),
                deferredSideEffects: structuredClone([...(planned.deferredSideEffects ?? [])]),
            });
            break;
        }
    });
    return result;
}
//# sourceMappingURL=triggerPlanner.js.map